<script>
import { crudMethods } from '@state/helpers'
import Layout from '@layouts/main'
import CompProyek from './comp-proyek.vue'
import CompPanjar from './panjar/comp-panjar'
import CompIkhtisar from './ikhtisar/comp-ikhtisar.vue'
import CompTagihan from '@/src/router/views/pages/transaksi/proyek/tagihan/comp-tagihan.vue'
import CompRab from '@/src/router/views/pages/transaksi/proyek/rab/comp-rab.vue'
import CompDokumen from '@/src/router/views/pages/transaksi/proyek/dokumen/comp-dokumen.vue'

export default {
  components: {
    Layout,
    CompProyek,
    CompRab,
    CompPanjar,
    CompDokumen,
    CompTagihan,
    CompIkhtisar,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      parrentURL: '/transaksi/proyek',
      apiUrl: '/web/transaksi/proyek',
      detail: {},
    }
  },
  computed: {
    tab() {
      return this.$route.query.tab || 'proyek'
    },
    rabAuthorized() {
      return this.user.permissions['transaksi.proyek.rab'].view
    },
    panjarAuthorized() {
      return this.user.permissions['transaksi.proyek.data_panjar'].view
    },
    dokumenAuthorized() {
      return this.user.permissions['transaksi.proyek.dokumen'].view
    },
    settingTagihanAuthorized() {
      return this.user.permissions['transaksi.proyek.setting_tagihan'].view
    },
    ikhtisarAuthorized() {
      return this.user.permissions['transaksi.proyek.ikhtisar'].view
    },
  },
  mounted() {
    if (this.$route.params.id) this.getDetailData()
  },
  methods: {
    ...crudMethods,
    getDetailData() {
      this.listData({
        url: `${this.apiUrl}/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data
        this.detail = data
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="m-0 text-dark font-weight-bold">
            <i class="uil uil-briefcase-alt mr-2 text-primary"></i>
            {{
              detail.kode_proyek
                ? `Proyek : ${detail.kode_proyek}`
                : 'Buat Proyek Baru'
            }}
          </h4>
          <router-link
            :to="parrentURL"
            class="btn btn-primary height-36-px shadow-sm"
          >
            <i class="uil uil-arrow-circle-left mr-1"></i> KEMBALI
          </router-link>
        </div>

        <div class="card-folder-wrapper">
          <ul class="nav nav-tabs folder-tabs">
            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'proyek' } }"
                class="nav-link"
                :class="{ active: tab === 'proyek' }"
              >
                Proyek
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'rab' } }"
                class="nav-link"
                :class="[
                  { active: tab === 'rab' },
                  !detail.kode_proyek || !rabAuthorized ? 'disabled' : '',
                ]"
              >
                RAB
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'panjar' } }"
                class="nav-link"
                :class="[
                  { active: tab === 'panjar' },
                  !detail.kode_proyek || !panjarAuthorized ? 'disabled' : '',
                ]"
              >
                Data Panjar
              </router-link>
            </li>

            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'dokumen' } }"
                class="nav-link"
                :class="[
                  { active: tab === 'dokumen' },
                  !detail.kode_proyek || !dokumenAuthorized ? 'disabled' : '',
                ]"
              >
                Dokumen
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'tagihan' } }"
                class="nav-link"
                :class="[
                  { active: tab === 'tagihan' },
                  !detail.kode_proyek || !settingTagihanAuthorized
                    ? 'disabled'
                    : '',
                ]"
              >
                Setting Tagihan
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ query: { panel: $route.query.panel, tab: 'ikhtisar' } }"
                class="nav-link"
                :class="[
                  { active: tab === 'ikhtisar' },
                  !detail.kode_proyek || !ikhtisarAuthorized ? 'disabled' : '',
                ]"
              >
                Ikhtisar
              </router-link>
            </li>
          </ul>

          <div class="card card-custom-body shadow-sm">
            <div class="card-body">
              <div class="tab-fade-animation">
                <comp-proyek v-if="tab === 'proyek'" :user="user" />
                <comp-rab v-if="tab === 'rab' && rabAuthorized" :user="user" />
                <comp-panjar
                  v-if="tab === 'panjar' && panjarAuthorized"
                  :user="user"
                />
                <comp-ikhtisar
                  v-if="tab === 'ikhtisar' && panjarAuthorized"
                  :user="user"
                  :proyek="detail"
                />
                <comp-dokumen
                  v-if="tab === 'dokumen' && dokumenAuthorized"
                  :user="user"
                />
                <comp-tagihan
                  v-if="tab === 'tagihan' && settingTagihanAuthorized"
                  :user="user"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* Container untuk membungkus Tabs dan Card */
.card-folder-wrapper {
  margin-top: 20px;
}

/* Navigasi Gaya Folder */
.folder-tabs {
  border-bottom: none; /* Hilangkan garis bawah default bootstrap */
}

.folder-tabs .nav-item {
  margin-right: 5px; /* Jarak antar tab */
}

.folder-tabs .nav-link {
  background-color: #e2e8f0; /* Warna tab tidak aktif (abu-abu gelap) */
  color: #64748b;
  font-weight: 600;
  border: 1px solid #cbd5e1;
  border-bottom: none;
  border-radius: 10px 10px 0 0; /* Lengkungan hanya di atas */
  padding: 10px 25px;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
}

/* Tab Hover */
.folder-tabs .nav-link:hover:not(.disabled):not(.active) {
  background-color: #cbd5e1;
  color: #334155;
}

/* Gaya Tab Aktif (Menyatu dengan Card) */
.folder-tabs .nav-link.active {
  background-color: #ffffff; /* Sama dengan warna kartu */
  color: #3b82f6; /* Warna teks aktif */
  border-color: #cbd5e1;
  border-bottom: 1px solid #cbd5e1 !important; /* Trik agar menutupi border card body */
  margin-bottom: 1px; /* Menarik tab ke bawah agar menutup garis card */
  z-index: 3; /* Pastikan di atas border card */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.03);
}

/* Tab Aktif Indikator Atas (Opsional: Seperti di gambar ada titik/garis merah) */
.folder-tabs .nav-link.active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  /* background-color: #3b82f6; Garis biru di atas tab aktif */
  border-radius: 10px 10px 0 0;
}

/* Tab Disabled */
.folder-tabs .nav-link.disabled {
  background-color: #f1f5f9;
  color: #cbd5e1;
  cursor: not-allowed;
}

/* Body Card Custom */
.card-custom-body {
  border: 1px solid #cbd5e1;
  border-radius: 0 12px 12px 12px; /* Pojok kiri atas tajam karena ada tab */
  z-index: 2;
  position: relative;
  background: white;
}

/* Animasi Perpindahan Tab */
.tab-fade-animation {
  animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Perbaikan untuk tampilan Mobile */
@media (max-width: 768px) {
  .folder-tabs .nav-link {
    padding: 8px 12px;
    font-size: 12px;
  }
}
</style>
